import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TIER_META } from "@/components/Bits";
import { Check } from "lucide-react";

export default function Tiers() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/tiers").then((r) => setItems(r.data.items)); }, []);

  return (
    <div data-testid="tiers-page">
      <div className="mb-8">
        <div className="uppercase-tiny text-gray-500">Product</div>
        <h1 className="font-heading text-4xl tracking-tight mt-1">Partnership Tiers</h1>
        <p className="text-sm text-gray-600 mt-2 max-w-2xl">The four annual packages we sell to local sponsors. Bronze and Silver are entry-friendly; Gold adds homepage exposure; Platinum is our headline sponsor slot.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {items.map((t) => (
          <div key={t.id} className={`bg-white border border-gray-200 rounded-sm p-6 tier-border-${t.id}`} data-testid={`tier-card-${t.id}`}>
            <div className="flex items-baseline justify-between mb-3">
              <div className="font-heading text-2xl" style={{ color: TIER_META[t.id]?.color }}>{t.name}</div>
              <div className="font-heading text-3xl">£{t.price}</div>
            </div>
            <div className="text-xs text-gray-500 mb-4">{t.tagline} · {t.period}</div>
            <ul className="space-y-2 text-sm mb-6 min-h-[180px]">
              {t.features.map((f) => (
                <li key={f} className="flex items-start gap-2">
                  <Check className="h-3.5 w-3.5 text-[#1B4332] mt-0.5 flex-shrink-0" />
                  <span>{f}</span>
                </li>
              ))}
            </ul>
            <div className="text-xs italic text-gray-500 border-t border-gray-100 pt-3 mb-4">
              {t.use_case}
            </div>
            <div className="grid grid-cols-3 gap-2 text-center border-t border-gray-100 pt-4">
              <div>
                <div className="uppercase-tiny text-gray-500">Suggested</div>
                <div className="font-heading text-lg" data-testid={`tier-suggested-count-${t.id}`}>{t.suggested_count}</div>
              </div>
              <div>
                <div className="uppercase-tiny text-gray-500">Converted</div>
                <div className="font-heading text-lg" data-testid={`tier-converted-count-${t.id}`}>{t.converted_count}</div>
              </div>
              <div>
                <div className="uppercase-tiny text-gray-500">Revenue</div>
                <div className="font-heading text-lg" data-testid={`tier-revenue-${t.id}`}>£{t.revenue}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
